var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5052 4.01582V9.23718C14.5052 9.4559 14.3193 9.63651 14.092 9.63651C13.8604 9.63651 13.6736 9.4559 13.6736 9.23718V1.60982H11.1839V8.43351C11.1839 8.65324 10.9971 8.83283 10.7707 8.83283C10.5392 8.83283 10.3523 8.65324 10.3523 8.43351V0.806152H7.86274V8.43351C7.86274 8.65324 7.67586 8.83283 7.44434 8.83283C7.21802 8.83283 7.03114 8.65324 7.03114 8.43351V2.4135H4.54153V12.4468L2.85757 10.2204C2.35923 9.47999 1.38539 9.22915 0.67215 9.65657C-0.0379806 10.091 -0.212399 11.0392 0.278671 11.7806C0.278671 11.7806 2.99149 15.7468 4.14805 17.4435C5.30357 19.1451 7.17753 20.4735 10.6815 20.4735C16.4809 20.4735 17 16.1461 17 14.8528V4.01582H14.5052Z",
    fill: "#B9B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.9233ca1e4df0b193ed63969c5715b8b7.svg";
export { ForwardRef as ReactComponent };